import React, { memo } from 'react';
import block from 'bem-cn';
import isEqual from 'lodash.isequal';

import { PragmaticDGASicBo } from 'components/slots/PragmaticDGA/hooks';

import './SicBo.scss';

const b = block('pragmatic-dga-sic-bo');

type SicBoProps = {
  results: PragmaticDGASicBo['last20Results'];
};

const getColorType = ({
  die1,
  die2,
  die3,
  totalSum,
}: PragmaticDGASicBo['last20Results'][number]) => {
  if (die1 === die2 && die1 === die3) return 'triple';
  if (totalSum <= 10) return 'small';
  if (totalSum > 10) return 'big';
  return '';
};

export const SicBo = memo(({ results }: SicBoProps) => (
    <div className={b()}>
      {results.map((result, index) => (
        <div
          key={index}
          className={b('result', { type: getColorType(result) })}
        >
          {result.totalSum}
        </div>
      ))}
    </div>
), isEqual);
